import React, { FC, PropsWithChildren, useEffect } from 'react'
import ModalConnector, { ConnectorProps as ModalProps } from 'connectors/Modal'
import Content from './Content'
import { Standard, FullScreen } from './Layouts'

const getLayout = (layout: string): Record<string, any> => {
  switch (layout) {
    case 'fullscreen':
      return FullScreen

    case 'modal':
    default:
      return Standard
  }
}

type ModalComponentProps = ModalProps & {
  layout: string
  name: string
  // Used in SELECTORS to check REDUX modal state
  decayTime: number
  disableClose?: boolean
}

const Modal: FC<PropsWithChildren<ModalComponentProps>> = (props) => {
  const { children, closeModal, isModalAvailable, isVisible, layout, disableClose } = props

  if (!isModalAvailable) {
    return null
  }

  const Layout = getLayout(layout)
  return (
    <Content closeModal={closeModal} isVisible={isVisible}>
      {React.createElement(
        Layout,
        {
          closeModal,
          disableClose,
        },
        children
      )}
    </Content>
  )
}

export default ModalConnector(Modal)
